import React from 'react'
import clsx from 'clsx'
import style from './style.module.scss'

type underlinedMenuLinkProps = {
    link: string
    text: string
    className?: string
}

export const UnderlinedMenuLink: React.FC<underlinedMenuLinkProps> = ({
    link,
    text,
    className,
}) => {
    return (
        <a href={link} className={clsx(style.link, className)}>
            {text}
        </a>
    )
}
